import * as React from 'react';

const AppConfigContext = React.createContext({
  config: {}
});

export default AppConfigContext;
